import * as React from 'react';

import ListActions from 'components/ListActions';
import { ListActionsFilterState } from 'components/ListActions/ListActions';
import MediaObject from 'components/MediaObject';
import { GroupStatus } from 'groups/components/GroupList/GroupListTable';

export type Props = {
  filters: ListActionsFilterState;
  onFiltersChange: (activeFilters: ListActionsFilterState) => void;
  onQueryChange: (query: string) => void;
  onQueryClick?: () => void;
  activeCount: number;
  unclaimedCount: number;
};

function getFilterRows(activeCount: number, unclaimedCount: number) {
  return [
    createFilterRowDisplay('Active', activeCount),
    createFilterRowDisplay('Unclaimed', unclaimedCount),
  ];
}

function createFilterRowDisplay(label: string, count: number) {
  const shouldDisplay = count !== -1;

  return {
    display: (
      <MediaObject
        center
        key={label.toLowerCase()}
        gutter="xsmall"
        inline
        className="GroupListFilterView-actions-label">
        {label}
        {shouldDisplay && <span data-test="group-count-span">({count})</span>}
      </MediaObject>
    ),
    value: label.toLowerCase() as GroupStatus,
    label: label,
  };
}

const GroupListFilterView = (props: Props) => {
  const {
    onFiltersChange,
    onQueryChange,
    onQueryClick,
    filters,
    activeCount,
    unclaimedCount,
  } = props;

  const groupStatusListOptions = getFilterRows(activeCount, unclaimedCount);
  const selectedOption = groupStatusListOptions.find(item => item.value === filters.groupStatus);

  return (
    <ListActions
      data-test="list-actions"
      filterButtonFace={selectedOption && selectedOption.display}
      initialActiveFilters={filters as ListActionsFilterState}
      primaryFilters={[
        {
          inputProps: {
            nonTextLabel: false,
          },
          name: 'groupStatus',
          options: groupStatusListOptions,
          title: 'Status',
          type: 'radio',
        },
      ]}
      searchPlaceholder={`Search all ${filters.groupStatus} classes in your school`}
      onFilterChange={onFiltersChange}
      onQueryChange={onQueryChange}
      onQueryClick={onQueryClick}
      showDropDownWhileSearchActive={true}
    />
  );
};

export default GroupListFilterView;
